import { HeroDesktop } from '@/app/pages/LandingPage/Hero/HeroDesktop'
import { HeroMobile } from '@/app/pages/LandingPage/Hero/HeroMobile'
import type { FunctionalComponent } from 'preact'

export const Hero: FunctionalComponent = () => {
  return (
    <>
      <HeroDesktop />
      <HeroMobile />
    </>
  )
}
